import type { ReactNode } from "react";
import { Tooltip } from "@salesapp/ui";

/** CRM form label with an optional info-mark tooltip. */
export function FieldLabel({
  htmlFor,
  children,
  hint,
}: {
  htmlFor?: string;
  children: ReactNode;
  hint?: string;
}) {
  const labelText = typeof children === "string" ? children : "this field";
  if (!hint) {
    return (
      <label className="crm-field-label" htmlFor={htmlFor}>
        {children}
      </label>
    );
  }
  return (
    <label className="crm-field-label" htmlFor={htmlFor}>
      <Tooltip text={hint} label={`About ${labelText}`}>
        <span>{children}</span>
      </Tooltip>
    </label>
  );
}
